import axios from "axios";

export default axios.create({
  baseURL: "https://api.southteams.io/v1/",
  responseType: "json",
  headers: {
    Authorization: window.localStorage.getItem("token"),
  },
});
